import { Route } from '@angular/router';
import { SustainabilityDashboardComponent } from './sustainability-dashboard.component';

export const SustainabilityDashboardRoutes: Route = {
  path: '',
  component: SustainabilityDashboardComponent,
  children: [
    {
      path: '',
      pathMatch: 'full',
      redirectTo: 'home_',
    },
    {
      path: 'home_',
      loadComponent: () =>
        import('./components/home/sustainability-dashboard-home.component').then(
          (m) => m.SustainabilityDashboardHomeComponent
        ),
    },
    {
      path: 'water',
      loadComponent: () =>
        import('./components/water/sustainability-dashboard-water.component').then(
          (m) => m.SustainabilityDashboardWaterComponent
        ),
    },
    {
      path: 'soil',
      loadComponent: () =>
        import('./components/soil/sustainability-dashboard-soil.component').then(
          (m) => m.SustainabilityDashboardSoilComponent
        ),
    },
    {
      path: 'climate',
      loadComponent: () =>
        import('./components/climate/sustainability-dashboard-climate.component').then(
          (m) => m.SustainabilityDashboardClimateComponent
        ),
    },
    {
      path: 'biodiversity',
      loadComponent: () =>
        import('./components/biodiversity/sustainability-dashboard-biodiversity.component').then(
          (m) => m.SustainabilityDashboardBiodiversityComponent
        ),
    },
    {
      path: 'livelihood',
      loadComponent: () =>
        import('./components/livelihood/sustainability-dashboard-livelihood.component').then(
          (m) => m.SustainabilityDashboardLivelihoodComponent
        ),
    },
  ],
};
